import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { localStorageService } from '../../services/localStorage';

interface TitleSuggestionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TitleSuggestionsDialog({ open, onOpenChange }: TitleSuggestionsDialogProps) {
  const { t } = useTranslation();
  const [textValue, setTextValue] = useState('');

  // Load existing titles when dialog opens
  useEffect(() => {
    if (open) {
      const existing = localStorageService.getManualTitles();
      setTextValue(existing.join('\n'));
    }
  }, [open]);

  function handleSave() {
    const titles = textValue
      .split('\n')
      .map(t => t.trim())
      .filter(t => t.length > 0);

    localStorageService.setManualTitles(titles);
    onOpenChange(false);
  }

  function handleCancel() {
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{t('titleSuggestions.dialogTitle')}</DialogTitle>
          <DialogDescription>
            {t('titleSuggestions.dialogDescription')}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <Textarea
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            rows={10}
            placeholder={t('titleSuggestions.placeholder')}
            className="resize-none"
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleSave}>
            {t('common.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
